import type { DocNode } from '@atlaskit/adf-schema/doc';
import { reduce } from '@atlaskit/adf-utils/traverse';

export const extractTextFromDocNode = (docNode: DocNode | undefined): string => {
	if (!docNode) {
		return '';
	}

	const text = reduce(
		docNode,
		(acc, node) => (node.type === 'text' ? acc + (node.text || '') : acc),
		'',
	);

	return text.trim();
};
